// Auto generated file, do not manually modify!
// com.hotpads.leasing.client.enums.LeaseTemplateBundleType

export enum LeaseTemplateBundleType {
  CLAUSE_MANAGEMENT = 'CLAUSE_MANAGEMENT',
  COSMOS_POWERED = 'COSMOS_POWERED',
  DOTLOOP = 'DOTLOOP',
  SELF_UPLOAD = 'SELF_UPLOAD',
  SIGNED_SELF_UPLOAD = 'SIGNED_SELF_UPLOAD',
}

export const LeaseTemplateBundleType_values = [
  LeaseTemplateBundleType.CLAUSE_MANAGEMENT,
  LeaseTemplateBundleType.COSMOS_POWERED,
  LeaseTemplateBundleType.DOTLOOP,
  LeaseTemplateBundleType.SELF_UPLOAD,
  LeaseTemplateBundleType.SIGNED_SELF_UPLOAD,
] as const;
